import { BrowserRouter } from 'react-router';
import AppRoutes from './router/routes';
import './styles/app.scss';

function App() {
    return (
        <BrowserRouter basename="/maria-luisa-elio">
            <AppRoutes />
        </BrowserRouter>
    );
}

export default App;
